import React, { useState } from "react";
import FaqTable from "../components/Inquiries/FaqTable";


const dummyData = Array.from({ length: 4 }, (_, i) => ({
 id: i + 1,
 question: `What is Overview ${i + 1}?`,
  answer: `Aruhi Fragrances offers premium, long-lasting perfumes designed to create a signature scent for every individual. ${i + 1}`,
}));

const ITEMS_PER_PAGE = 10;

const Faqs = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;

  return (
    <div className="flex flex-col w-full gap-4">
  {/* Header */}
  <div className="bg-gray-700 p-3 w-full">
    <h1 className="font-bold text-[1.3rem]">Manage Faqs Inquiries</h1>
  </div>

  {/* Content */}
  <div className="p-2 w-full bg-gray-700">
    <FaqTable
      data={dummyData.slice(startIndex, endIndex)}
      currentPage={currentPage}
      totalPages={Math.ceil(dummyData.length / ITEMS_PER_PAGE)}
      onPageChange={handlePageChange}
    />
  </div>
</div>

  );
};

export default Faqs;
